import React, { Component } from 'react';

import { 
  Add, 
} from '@mui/icons-material';
import { Fab, Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  SuggestedSpells,
  SuggestionsForLevel,
  SuggestionsOfType,
  Spell
} from "@dndModels";

import API from "@dndUtilities/system_api";

import SuggestionsForLevelInput from "@dndComponents/feature/SuggestionsForLevelInput";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import LoadingBox from "@components/input/LoadingBox";
import { isDataType } from '@dndModels/Types';

type Props = {
  obj: SuggestedSpells;
  onChange: (changed: SuggestedSpells) => void; 
  disabled: boolean;
}

export interface State { 
  reloading: boolean;
  suggestions: SuggestionsForLevel[];
  spells: Spell[];
  expanded_level: number;
  loading: boolean;
}

const api = API.getInstance();

class SuggestionsInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      reloading: false,
      suggestions: props.obj.suggestions,
      expanded_level: 0,
      spells: [],
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getSetOfObjects({ data_types: ["spell"]}).then(res => {
        this.setState({
          spells: res.spell as Spell[],
          loading: false
        });
      });
    });
  }

  parse_description() {
    const pieces = this.props.obj.description.split("\n");
    const obj = this.props.obj;
    obj.suggestions = [];
    let current_level_sug: SuggestionsForLevel | null = null;
    for (let i = 0; i < pieces.length; ++i) {
      const piece = pieces[i];
      if (piece.startsWith("Level")) {
        if (current_level_sug) {
          obj.suggestions.push(current_level_sug);
        }
        const level_pieces = piece.split(" ");
        current_level_sug = { level: +level_pieces[1], suggestions: [] };
      } else if (current_level_sug && piece.trim().length > 0) {
        const type_pieces = piece.split(":");
        let type = type_pieces[0];
        if (type.endsWith("s")) {
          type = type.substring(0, type.length - 1);
        }
        type = type.toLowerCase();
        if (isDataType(type)) {
          const suggestions = type_pieces[1].split(",");
          const type_sug: SuggestionsOfType = {
            type,
            ids: []
          };
          if (["spell","cantrip"].includes(type)) {
            for (let j = 0; j < suggestions.length; ++j) {
              const suggestion_string = suggestions[j].trim();
              const spell_finder = this.state.spells.filter(o => 
                o.name.toLowerCase() === suggestion_string.toLowerCase());
              if (spell_finder.length === 1) {
                type_sug.ids.push(spell_finder[0]._id);
              }
            }
          }
          current_level_sug.suggestions.push(type_sug);
        }
      }
    }
    if (current_level_sug) {
      obj.suggestions.push(current_level_sug);
    }
    this.setState({ 
      suggestions: obj.suggestions
    }, () => {
      this.props.onChange(obj);
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else {
      let next_level = this.state.suggestions.length === 0 ? 0 : Math.max(...this.state.suggestions.map(o => { return o.level; }));
      next_level++;
      return (
        <Grid container spacing={0} direction="column">
          <Grid style={{ color: "blue", fontWeight: "bold" }}>
            Suggestions
            <Tooltip title={`Create New Suggestion`}>
              <Fab size="small" color="primary" style={{marginLeft: "8px"}}
                disabled={ this.props.disabled || next_level === 21 }
                onClick={ () => {
                  const suggestions = this.state.suggestions;
                  suggestions.push({ level: next_level, suggestions: [] });
                  this.setState({ 
                    suggestions, 
                    expanded_level: next_level,
                    // reloading: true 
                  }, () => {
                    const obj = this.props.obj;
                    obj.suggestions = suggestions;
                    this.props.onChange(obj);
                    // this.setState({ reloading: false });
                  });
                }}>
                <Add/>
              </Fab>
            </Tooltip>
            <ButtonBox
              name="Parse Description"
              onClick={() => {
                this.parse_description();
              }}
            />
          </Grid>
          { !this.state.reloading && this.state.suggestions.sort((a,b) => { 
            return +a.level < +b.level ? -1 : 1;
          }).map((level_sug, key) => {
            return (
              <Grid key={key} container spacing={0} direction="column">
                <Grid>
                  <ToggleButtonBox 
                    name={ `${level_sug.level}` }
                    value={ this.state.expanded_level === level_sug.level }
                    onToggle={() => {
                      this.setState({ expanded_level: (this.state.expanded_level === level_sug.level ? 0 : level_sug.level) });
                    }}
                  />
                </Grid>
                { this.state.expanded_level === level_sug.level &&
                  <Grid container spacing={0} direction="row">
                    <Grid
                      size={{
                        xs: 1
                      }}>
                    </Grid>
                    <Grid
                      size={{
                        xs: 11
                      }}>
                      <SuggestionsForLevelInput
                        obj={level_sug} 
                        disabled={this.props.disabled}
                        onChange={(changed: SuggestionsForLevel) => {
                          const suggestions = this.state.suggestions;
                          const sug_finder = suggestions.filter(o => o.level === level_sug.level);
                          if (sug_finder.length === 1) {
                            const sug = sug_finder[0];
                            if (changed.level === level_sug.level) {
                              sug.suggestions = changed.suggestions.map(o => { return { type: o.type, ids: [...o.ids] }; });
                            } else {
                              sug.level = changed.level;
                            }
                            this.setState({ 
                              suggestions, 
                              // reloading: true 
                            }, () => {
                              const obj = this.props.obj;
                              obj.suggestions = suggestions;
                              this.props.onChange(obj);
                              // this.setState({ reloading: false });
                            });
                          }
                        }}
                        onDelete={() => {
                          const suggestions = this.state.suggestions.filter(o => o.level !== level_sug.level);
                          this.setState({ suggestions, reloading: true }, () => {
                            const obj = this.props.obj;
                            obj.suggestions = suggestions;
                            this.props.onChange(obj);
                            this.setState({ reloading: false });
                          });
                        }}
                      />
                    </Grid>
                  </Grid>
                }
              </Grid>
            );
          })}
        </Grid>
      );
    }
  }
}

export default SuggestionsInput;
